import { Store, ChefHat, LogOut } from 'lucide-react';

const iconFor = (type) => (type === 'central_kitchen' ? ChefHat : Store);

export default function LocationChooser({ locations, onPick, user, onLogout }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-stone-900 p-6" data-testid="location-chooser">
      <div className="text-center mb-10">
        <h1 className="font-heading text-3xl sm:text-4xl font-bold text-white">Where are you working today?</h1>
        <p className="text-stone-400 mt-2">Hi {user?.name || 'there'} — select your location to continue</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 w-full max-w-2xl">
        {locations.map((loc) => {
          const Icon = iconFor(loc.type);
          return (
            <button
              key={loc.location_id}
              data-testid={`choose-location-${loc.location_id}`}
              onClick={() => onPick(loc)}
              className="group flex flex-col items-center gap-3 bg-stone-800 border-2 border-stone-700 hover:border-secondary rounded-xl p-8 transition-all hover:-translate-y-1"
            >
              <div className="w-16 h-16 rounded-full bg-secondary/15 flex items-center justify-center group-hover:bg-secondary/25 transition-colors">
                <Icon size={30} className="text-secondary" />
              </div>
              <div className="text-center">
                <div className="text-lg font-semibold text-white">{loc.name}</div>
                <div className="text-xs text-stone-400 capitalize mt-0.5">{loc.type.replace('_', ' ')}</div>
              </div>
            </button>
          );
        })}
      </div>

      <button
        data-testid="chooser-logout"
        onClick={onLogout}
        className="mt-10 flex items-center gap-2 text-stone-400 hover:text-white transition-colors text-sm"
      >
        <LogOut size={16} /> Log out
      </button>
    </div>
  );
}
